import { defineStore } from 'pinia'
import { useLocalStorage } from '@vueuse/core'
import { useI18n } from 'vue-i18n'
import { computed, nextTick, ref, watch } from 'vue'
export const useSettingStore = defineStore('settingStore', () => {
  const { t, locale } = useI18n()
  const langStorage = useLocalStorage('__K__LANG', locale.value)
  const fixAppLang = () => {
    locale.value = langStorage.value
  }
  fixAppLang()
  const lang = computed(() => langStorage.value)

  const setAppLang = (val: string) => {
    langStorage.value = val
    locale.value = val
    fixAppLang()
  }
  return { lang, langStorage, setAppLang }
})
